import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import { LibraryComponent } from './library/library.component';
import { SingleImageViewComponent } from './single-image-view/single-image-view.component';
import { LoginWrapperComponent } from './login-wrapper/login-wrapper.component';
import { GatewayComponent } from './gateway-component/gateway.component';
import { AuthGuardService, GoogleBotAuthGuardService, ImageAuthGuardService, ImageGoogleBotAuthGuardService, LibAuthGuardService, LoggedInService } from './auth-guard.service';
import { AdminAuthGuardService } from './admin-auth-guard.service';
import { LookupTableWrapperComponent } from './lookup-table-wrapper/lookup-table-wrapper.component';
import { SaveFormGuardService } from './save-form-guard.service';
import { SearchComponent } from './search/search.component';
import { QuartermasterManualComponent } from './quartermaster-manuals/quartermaster-manuals.component';
import { AdminDashboardComponent } from './contact/admin-dashboard.component';
import { LogScreenComponent } from './log-screen/log-screen.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { AttributionComponent } from './attribution/attribution.component';
import { AccessibilityComponent } from './accessibility/accessibility.component';
import { AboutComponent } from './about/about.component';
import { TakedownComponent } from './takedown/takedown.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  { path: 'login', component: LoginWrapperComponent, canActivate: [LoggedInService] },
  { path: 'login/image/:id', component: LoginWrapperComponent, canActivate: [LoggedInService] },
  { path: 'login/out', component: LoginWrapperComponent, data: { out: -1 }, canActivate: [LoggedInService]  },
  { path: 'login/out', component: LoginWrapperComponent, data: { token: '' }, canActivate: [LoggedInService]  },
  { path: 'login/out', component: LoginWrapperComponent, data: { contactus: 0 }, canActivate: [LoggedInService]  },
  { path: 'signup', component: SignUpComponent, canDeactivate: [SaveFormGuardService], canActivate: [LoggedInService]  },
  /* Authorized routes... */
  { path: 'library', component: LibraryComponent, canActivate: [AuthGuardService] },
  { path: 'library/:library', component: LibraryComponent, canActivate: [AuthGuardService] },
  {
    path: 'imageSingleView/:id',
    component: SingleImageViewComponent,
    canActivate: [ImageGoogleBotAuthGuardService],
    canDeactivate: [SaveFormGuardService]
  },
  {
    path: 'imageSingleView/:id/:qmid',
    component: SingleImageViewComponent,
    canActivate: [ImageAuthGuardService],
    canDeactivate: [SaveFormGuardService]
  },
  { path: 'gateway', component: GatewayComponent, canActivate: [AuthGuardService]},
  { path: 'gateway', component: GatewayComponent, data: { contactus: 0 }, canActivate: [AuthGuardService]},
  { path: 'dashboard', component: AdminDashboardComponent, canActivate: [AdminAuthGuardService]},
  { path: 'logs', component: LogScreenComponent, canActivate: [AdminAuthGuardService]},
  {
    path: 'lookup-tables', component: LookupTableWrapperComponent, canActivate: [LibAuthGuardService], canDeactivate: [SaveFormGuardService]
  },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuardService]},
  { path: 'search/:search', component: SearchComponent, canActivate: [AuthGuardService]},
  { path: 'quartermaster-manuals', component: QuartermasterManualComponent, canActivate: [AuthGuardService]},
  { path: 'quartermaster-manuals/:id', component: QuartermasterManualComponent, canActivate: [GoogleBotAuthGuardService]},
  { path: 'attribution', component: AttributionComponent},
  { path: 'accessibility', component: AccessibilityComponent},
  { path: 'about', component: AboutComponent},
  { path: 'takedown', component: TakedownComponent},
  { path: '**', component: LoginWrapperComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers: [ AuthGuardService, AdminAuthGuardService, LibAuthGuardService, SaveFormGuardService ]
})

export class AppRoutingModule { }
